export const accessesKeys = {
  canChangeLifeCycle: 'canChangeLifeCycle',
};

export const defaultAccesses = {
  [accessesKeys.canChangeLifeCycle]: false,
};
